module.exports = '<svg width="24" height="32" viewBox="0 0 24 32"><path d="M22 14v-4c0-5.524-4.476-10-10-10S2 4.476 2 10v4c-1.106 0-2 .894-2 2v14c0 1.106.894 2 2 2h20c1.106 0 2-.894 2-2V16c0-1.106-.894-2-2-2zM12 4c3.308 0 6 2.692 6 6v4H6v-4c0-3.308 2.692-6 6-6z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/lock-1.js
// module id = 1243
// module chunks = 14